<template>
  <div>
    <div class="case" ref="box">
      <img class="caseimg1" src="../assets/images/table_chailv.png">
      <div class="caseword">
        <p class="Baoxiaobumen">{{Baoxiaobumen}}</p>
        <p class="Xingming">{{Xingming}}</p>
        <p class="Tianzhiriqi">{{Tianzhiriqi}}</p>
        <p class="Chuchaishiyou">{{Chuchaishiyou}}</p>
        <p class="Chuchaibegintime">{{Chuchaibegintime}}</p>
        <p class="ZongTianShu">{{ZongTianShu}}</p>
        <p class="FuJianNum">{{FuJianNum}}</p>
        <p class="Chuchaiendtime">{{Chuchaiendtime}}</p>
        <p class="Yuzhi">{{Yuzhi}}</p>
        <p class="Tuibu">{{Tuibu}}</p>
        <p class="Lingkuanren">{{Lingkuanren}}</p>
        <p class="Bumenzhuguan">{{Bumenzhuguan}}</p>
        <p class="Caiwu">{{Caiwu}}</p>
        <p class="Fuzongjingli">{{Fuzongjingli}}</p>
        <p class="Zongjingli">{{Zongjingli}}</p>
        <p class="Chuna">{{Chuna}}</p>
        <!-- 第一行 -->
        <p class="L1 riqiyue">{{L1riqiyue}}</p>
        <p class="L1 riqiri">{{L1riqiri}}</p>
        <p class="L1 qidian">{{L1qidian}}</p>
        <p class="L1 zhongdian">{{L1zhongdian}}</p>
        <p class="L1 tianshu">{{L1tianshu}}</p>
        <p class="L1 huochejipiao">{{L1huochejipiao}}</p>
        <p class="L1 jiaotongfei">{{L1jiaotongfei}}</p>
        <p class="L1 zhusufei">{{L1zhusufei}}</p>
        <p class="L1 butie">{{L1butie}}</p>
        <p class="L1 qita">{{L1qita}}</p>
        <p class="L1 xiaoji">{{L1xiaoji}}</p>
        <!-- 第二行 -->
        <p class="L2 riqiyue">{{L2riqiyue}}</p>
        <p class="L2 riqiri">{{L2riqiri}}</p>
        <p class="L2 qidian">{{L2qidian}}</p>
        <p class="L2 zhongdian">{{L2zhongdian}}</p>
        <p class="L2 tianshu">{{L2tianshu}}</p>
        <p class="L2 huochejipiao">{{L2huochejipiao}}</p>
        <p class="L2 jiaotongfei">{{L2jiaotongfei}}</p>
        <p class="L2 zhusufei">{{L2zhusufei}}</p>
        <p class="L2 butie">{{L2butie}}</p>
        <p class="L2 qita">{{L2qita}}</p>
        <p class="L2 xiaoji">{{L2xiaoji}}</p>
        <!-- 第三行 -->
        <p class="L3 riqiyue">{{L3riqiyue}}</p>
        <p class="L3 riqiri">{{L3riqiri}}</p>
        <p class="L3 qidian">{{L3qidian}}</p>
        <p class="L3 zhongdian">{{L3zhongdian}}</p>
        <p class="L3 tianshu">{{L3tianshu}}</p>
        <p class="L3 huochejipiao">{{L3huochejipiao}}</p>
        <p class="L3 jiaotongfei">{{L3jiaotongfei}}</p>
        <p class="L3 zhusufei">{{L3zhusufei}}</p>
        <p class="L3 butie">{{L3butie}}</p>
        <p class="L3 qita">{{L3qita}}</p>
        <p class="L3 xiaoji">{{L3xiaoji}}</p>
        <!-- 第四行 -->
        <p class="L4 riqiyue">{{L4riqiyue}}</p>
        <p class="L4 riqiri">{{L4riqiri}}</p>
        <p class="L4 qidian">{{L4qidian}}</p>
        <p class="L4 zhongdian">{{L4zhongdian}}</p>
        <p class="L4 tianshu">{{L4tianshu}}</p>
        <p class="L4 huochejipiao">{{L4huochejipiao}}</p>
        <p class="L4 jiaotongfei">{{L4jiaotongfei}}</p>
        <p class="L4 zhusufei">{{L4zhusufei}}</p>
        <p class="L4 butie">{{L4butie}}</p>
        <p class="L4 qita">{{L4qita}}</p>
        <p class="L4 xiaoji">{{L4xiaoji}}</p>
        <!-- 第五行 -->
        <p class="L5 riqiyue">{{L5riqiyue}}</p>
        <p class="L5 riqiri">{{L5riqiri}}</p>
        <p class="L5 qidian">{{L5qidian}}</p>
        <p class="L5 zhongdian">{{L5zhongdian}}</p>
        <p class="L5 tianshu">{{L5tianshu}}</p>
        <p class="L5 huochejipiao">{{L5huochejipiao}}</p>
        <p class="L5 jiaotongfei">{{L5jiaotongfei}}</p>
        <p class="L5 zhusufei">{{L5zhusufei}}</p>
        <p class="L5 butie">{{L5butie}}</p>
        <p class="L5 qita">{{L5qita}}</p>
        <p class="L5 xiaoji">{{L5xiaoji}}</p>
        <!-- 第六行 -->
        <p class="L6 riqiyue">{{L6riqiyue}}</p>
        <p class="L6 riqiri">{{L6riqiri}}</p>
        <p class="L6 qidian">{{L6qidian}}</p>
        <p class="L6 zhongdian">{{L6zhongdian}}</p>
        <p class="L6 tianshu">{{L6tianshu}}</p>
        <p class="L6 huochejipiao">{{L6huochejipiao}}</p>
        <p class="L6 jiaotongfei">{{L6jiaotongfei}}</p>
        <p class="L6 zhusufei">{{L6zhusufei}}</p>
        <p class="L6 butie">{{L6butie}}</p>
        <p class="L6 qita">{{L6qita}}</p>
        <p class="L6 xiaoji">{{L6xiaoji}}</p>
        <!-- 合计 -->
        <p class="L7 huochejipiao">{{L7huochejipiao}}</p>
        <p class="L7 jiaotongfei">{{L7jiaotongfei}}</p>
        <p class="L7 zhusufei">{{L7zhusufei}}</p>
        <p class="L7 butie">{{L7butie}}</p>
        <p class="L7 qita">{{L7qita}}</p>
        <p class="L7 xiaoji">{{L7xiaoji}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      Baoxiaobumen: '',
      Xingming: '',
      Tianzhiriqi: '',
      Chuchaishiyou: '',
      Chuchaibegintime: '',
      ZongTianShu: '',
      FuJianNum: '',
      Chuchaiendtime: '',
      Yuzhi: '',
      Tuibu: '',
      Lingkuanren: '',
      Bumenzhuguan: '',
      Caiwu: '',
      Fuzongjingli: '',
      Zongjingli: '',
      Chuna: '',
      // 第一行
      L1riqiyue: '',
      L1riqiri: '',
      L1qidian: '',
      L1zhongdian: '',
      L1tianshu: '',
      L1huochejipiao: '',
      L1jiaotongfei: '',
      L1zhusufei: '',
      L1butie: '',
      L1qita: '',
      L1xiaoji: '',
      // 第二行
      L2riqiyue: '',
      L2riqiri: '',
      L2qidian: '',
      L2zhongdian: '',
      L2tianshu: '',
      L2huochejipiao: '',
      L2jiaotongfei: '',
      L2zhusufei: '',
      L2butie: '',
      L2qita: '',
      L2xiaoji: '',
      // 第三行
      L3riqiyue: '',
      L3riqiri: '',
      L3qidian: '',
      L3zhongdian: '',
      L3tianshu: '',
      L3huochejipiao: '',
      L3jiaotongfei: '',
      L3zhusufei: '',
      L3butie: '',
      L3qita: '',
      L3xiaoji: '',
      // 第四行
      L4riqiyue: '',
      L4riqiri: '',
      L4qidian: '',
      L4zhongdian: '',
      L4tianshu: '',
      L4huochejipiao: '',
      L4jiaotongfei: '',
      L4zhusufei: '',
      L4butie: '',
      L4qita: '',
      L4xiaoji: '',
      // 第五行
      L5riqiyue: '',
      L5riqiri: '',
      L5qidian: '',
      L5zhongdian: '',
      L5tianshu: '',
      L5huochejipiao: '',
      L5jiaotongfei: '',
      L5zhusufei: '',
      L5butie: '',
      L5qita: '',
      L5xiaoji: '',
      // 第六行
      L6riqiyue: '',
      L6riqiri: '',
      L6qidian: '',
      L6zhongdian: '',
      L6tianshu: '',
      L6huochejipiao: '',
      L6jiaotongfei: '',
      L6zhusufei: '',
      L6butie: '',
      L6qita: '',
      L6xiaoji: '',
      // 合计
      L7huochejipiao: '',
      L7jiaotongfei: '',
      L7zhusufei: '',
      L7butie: '',
      L7qita: '',
      L7xiaoji: ''
    }
  },
  mounted () {
  },
  methods: {
    InitData () {
      this.Baoxiaobumen = ''
      this.Xingming = ''
      this.Tianzhiriqi = ''
      this.Chuchaishiyou = ''
      this.Chuchaibegintime = ''
      this.ZongTianShu = ''
      this.FuJianNum = ''
      this.Chuchaiendtime = ''
      this.Yuzhi = ''
      this.Tuibu = ''
      this.Lingkuanren = ''
      this.Bumenzhuguan = ''
      this.Caiwu = ''
      this.Fuzongjingli = ''
      this.Zongjingli = ''
      this.Chuna = ''
      // 第一行
      this.L1riqiyue = ''
      this.L1riqiri = ''
      this.L1qidian = ''
      this.L1zhongdian = ''
      this.L1tianshu = ''
      this.L1huochejipiao = ''
      this.L1jiaotongfei = ''
      this.L1zhusufei = ''
      this.L1butie = ''
      this.L1qita = ''
      this.L1xiaoji = ''
      // 第二行
      this.L2riqiyue = ''
      this.L2riqiri = ''
      this.L2qidian = ''
      this.L2zhongdian = ''
      this.L2tianshu = ''
      this.L2huochejipiao = ''
      this.L2jiaotongfei = ''
      this.L2zhusufei = ''
      this.L2butie = ''
      this.L2qita = ''
      this.L2xiaoji = ''
      // 第三行
      this.L3riqiyue = ''
      this.L3riqiri = ''
      this.L3qidian = ''
      this.L3zhongdian = ''
      this.L3tianshu = ''
      this.L3huochejipiao = ''
      this.L3jiaotongfei = ''
      this.L3zhusufei = ''
      this.L3butie = ''
      this.L3qita = ''
      this.L3xiaoji = ''
      // 第四行
      this.L4riqiyue = ''
      this.L4riqiri = ''
      this.L4qidian = ''
      this.L4zhongdian = ''
      this.L4tianshu = ''
      this.L4huochejipiao = ''
      this.L4jiaotongfei = ''
      this.L4zhusufei = ''
      this.L4butie = ''
      this.L4qita = ''
      this.L4xiaoji = ''
      // 第五行
      this.L5riqiyue = ''
      this.L5riqiri = ''
      this.L5qidian = ''
      this.L5zhongdian = ''
      this.L5tianshu = ''
      this.L5huochejipiao = ''
      this.L5jiaotongfei = ''
      this.L5zhusufei = ''
      this.L5butie = ''
      this.L5qita = ''
      this.L5xiaoji = ''
      // 第六行
      this.L6riqiyue = ''
      this.L6riqiri = ''
      this.L6qidian = ''
      this.L6zhongdian = ''
      this.L6tianshu = ''
      this.L6huochejipiao = ''
      this.L6jiaotongfei = ''
      this.L6zhusufei = ''
      this.L6butie = ''
      this.L6qita = ''
      this.L6xiaoji = ''
      // 合计
      this.L7huochejipiao = ''
      this.L7jiaotongfei = ''
      this.L7zhusufei = ''
      this.L7butie = ''
      this.L7qita = ''
      this.L7xiaoji = ''
    },
    LoadData (parentdata, forprint) {
      this.InitData()
      var that = this
      this.$nextTick(() => {
        that.Baoxiaobumen = parentdata.CurJigouName
        that.Xingming = parentdata.Name1
        that.Tianzhiriqi = Vue.prototype.SplitTimeString(parentdata.Createtime)
        that.Chuchaishiyou = parentdata.Reason
        that.Chuchaibegintime = parentdata.Ccdaybegin
        that.ZongTianShu = parentdata.Ccdays
        that.FuJianNum = parentdata.Ccattachmentnum
        that.Chuchaiendtime = parentdata.Ccdayend
        that.Yuzhi = parentdata.Ccyuzhi
        that.Tuibu = parentdata.Cctuibu
        that.Lingkuanren = ''
        that.Bumenzhuguan = parentdata.Name2
        that.Caiwu = parentdata.Name3
        that.Fuzongjingli = parentdata.Name4
        that.Zongjingli = parentdata.Name5
        if (forprint == 0) {
          that.Chuna = ''
        } else {
          that.Chuna = localStorage.getItem('Nicename')
        }
        that.apiGetShenPiNewFyBxChaiLvSubList(parentdata.Orderid)
      })
    },
    apiGetShenPiNewFyBxChaiLvSubList: function (orderid) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: orderid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetShenPiNewFyBxChaiLvSubList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            var dataList = response.data.List
            for (var i = 0; i < dataList.length - 1; i++) {
              if (i == 0) {
                that.L1riqiyue = dataList[i].Datemonth
                that.L1riqiri = dataList[i].Dateday
                that.L1qidian = dataList[i].Addressbegin
                that.L1zhongdian = dataList[i].Addressend
                that.L1tianshu = dataList[i].Days
                that.L1huochejipiao = dataList[i].Huochejipiao
                that.L1jiaotongfei = dataList[i].Jiaotongfei
                that.L1zhusufei = dataList[i].Zhusufei
                that.L1butie = dataList[i].Butie
                that.L1qita = dataList[i].Qita
                that.L1xiaoji = dataList[i].Xiaoji
              }
              if (i == 1) {
                that.L2riqiyue = dataList[i].Datemonth
                that.L2riqiri = dataList[i].Dateday
                that.L2qidian = dataList[i].Addressbegin
                that.L2zhongdian = dataList[i].Addressend
                that.L2tianshu = dataList[i].Days
                that.L2huochejipiao = dataList[i].Huochejipiao
                that.L2jiaotongfei = dataList[i].Jiaotongfei
                that.L2zhusufei = dataList[i].Zhusufei
                that.L2butie = dataList[i].Butie
                that.L2qita = dataList[i].Qita
                that.L2xiaoji = dataList[i].Xiaoji
              }
              if (i == 2) {
                that.L3riqiyue = dataList[i].Datemonth
                that.L3riqiri = dataList[i].Dateday
                that.L3qidian = dataList[i].Addressbegin
                that.L3zhongdian = dataList[i].Addressend
                that.L3tianshu = dataList[i].Days
                that.L3huochejipiao = dataList[i].Huochejipiao
                that.L3jiaotongfei = dataList[i].Jiaotongfei
                that.L3zhusufei = dataList[i].Zhusufei
                that.L3butie = dataList[i].Butie
                that.L3qita = dataList[i].Qita
                that.L3xiaoji = dataList[i].Xiaoji
              }
              if (i == 3) {
                that.L4riqiyue = dataList[i].Datemonth
                that.L4riqiri = dataList[i].Dateday
                that.L4qidian = dataList[i].Addressbegin
                that.L4zhongdian = dataList[i].Addressend
                that.L4tianshu = dataList[i].Days
                that.L4huochejipiao = dataList[i].Huochejipiao
                that.L4jiaotongfei = dataList[i].Jiaotongfei
                that.L4zhusufei = dataList[i].Zhusufei
                that.L4butie = dataList[i].Butie
                that.L4qita = dataList[i].Qita
                that.L4xiaoji = dataList[i].Xiaoji
              }
              if (i == 4) {
                that.L5riqiyue = dataList[i].Datemonth
                that.L5riqiri = dataList[i].Dateday
                that.L5qidian = dataList[i].Addressbegin
                that.L5zhongdian = dataList[i].Addressend
                that.L5tianshu = dataList[i].Days
                that.L5huochejipiao = dataList[i].Huochejipiao
                that.L5jiaotongfei = dataList[i].Jiaotongfei
                that.L5zhusufei = dataList[i].Zhusufei
                that.L5butie = dataList[i].Butie
                that.L5qita = dataList[i].Qita
                that.L5xiaoji = dataList[i].Xiaoji
              }
              if (i == 5) {
                that.L6riqiyue = dataList[i].Datemonth
                that.L6riqiri = dataList[i].Dateday
                that.L6qidian = dataList[i].Addressbegin
                that.L6zhongdian = dataList[i].Addressend
                that.L6tianshu = dataList[i].Days
                that.L6huochejipiao = dataList[i].Huochejipiao
                that.L6jiaotongfei = dataList[i].Jiaotongfei
                that.L6zhusufei = dataList[i].Zhusufei
                that.L6butie = dataList[i].Butie
                that.L6qita = dataList[i].Qita
                that.L6xiaoji = dataList[i].Xiaoji
              }
            }
            that.L7huochejipiao = dataList[dataList.length - 1].Huochejipiao
            that.L7jiaotongfei = dataList[dataList.length - 1].Jiaotongfei
            that.L7zhusufei = dataList[dataList.length - 1].Zhusufei
            that.L7butie = dataList[dataList.length - 1].Butie
            that.L7qita = dataList[dataList.length - 1].Qita
            that.L7xiaoji = dataList[dataList.length - 1].Xiaoji
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.case{
    width: 839px;
    height: 451px;
    position: relative;
}

.caseimg1{
  width: 839px;
  height: 451px;
  position: absolute;
  z-index: 10;
}

.caseword{
  color:#000000;
  font-size: 14px;
}

.Baoxiaobumen{
  position: absolute;
  z-index: 30;
  left: 80px;
  top: 20px;
}

.Xingming{
  position: absolute;
  z-index: 30;
  left: 495px;
  top: 20px;
}

.Tianzhiriqi{
  position: absolute;
  z-index: 30;
  left: 703px;
  top: 20px;
}

.Chuchaishiyou{
  position: absolute;
  z-index: 30;
  left: 80px;
  top: 54px;
  right: 5px;
  word-wrap: break-word;
  word-break: break-all;
}

.Chuchaibegintime{
  position: absolute;
  z-index: 30;
  left: 148px;
  top: 112px;
}

.Chuchaiendtime{
  position: absolute;
  z-index: 30;
  left: 355px;
  top: 112px;
}

.ZongTianShu{
  position: absolute;
  z-index: 30;
  left: 558px;
  top: 112px;
}

.FuJianNum{
  position: absolute;
  z-index: 30;
  left: 772px;
  top: 112px;
}

.Yuzhi{
  position: absolute;
  z-index: 30;
  left: 80px;
  top: 382px;
}

.Tuibu{
  position: absolute;
  z-index: 30;
  left: 495px;
  top: 382px;
}

.Lingkuanren{
  position: absolute;
  z-index: 30;
  left: 80px;
  top: 412px;
}

.Bumenzhuguan{
  position: absolute;
  z-index: 30;
  left: 215px;
  top: 412px;
}

.Caiwu{
  position: absolute;
  z-index: 30;
  left: 350px;
  top: 412px;
}

.Fuzongjingli{
  position: absolute;
  z-index: 30;
  left: 488px;
  top: 412px;
}

.Zongjingli{
  position: absolute;
  z-index: 30;
  left: 625px;
  top: 412px;
}

.Chuna{
  position: absolute;
  z-index: 30;
  left: 770px;
  top: 412px;
}

//X轴定位
.riqiyue{
  left: 25px;
}
.riqiri{
  left: 88px;
}
.qidian{
  left: 143px;
}
.zhongdian{
  left: 213px;
}
.tianshu{
  left: 290px;
}
.huochejipiao{
  left: 348px;
}
.jiaotongfei{
  left: 419px;
}
.zhusufei{
  left: 490px;
}
.butie{
  left: 555px;
}
.qita{
  left: 628px;
}
.xiaoji{
  left: 700px;
}
// 第一行到第六行
.L1{
  position: absolute;
  z-index: 30;
  top: 170px;
}
.L2{
  position: absolute;
  z-index: 30;
  top: 200px;
}
.L3{
  position: absolute;
  z-index: 30;
  top: 230px;
}
.L4{
  position: absolute;
  z-index: 30;
  top: 260px;
}
.L5{
  position: absolute;
  z-index: 30;
  top: 290px;
}
.L6{
  position: absolute;
  z-index: 30;
  top: 320px;
}
.L7{
  position: absolute;
  z-index: 30;
  top: 350px;
}
</style>
